/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import uuid from 'react-uuid';

import { MdArrowBack } from 'react-icons/md';

import { useForm, Controller } from 'react-hook-form';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import LinearProgress from '@mui/material/LinearProgress';
import FormHelperText from '@mui/material/FormHelperText';

import FilesDropzone from './components/FilesDropzone';
import FileCard from './components/FileCard';
import SuccessModal from './components/SucessModal';

import ToasterBox from '../../../../components/singleComponents/toaster/ToasterBox';

import api, { authHeader } from '../../../../../services/API/apiConfig';

import {
  RootStyled,
  HeaderModalStyled,
  HeaderTitleStyled,
  Subtitle,
  FormContainer,
  FormTitle,
  FieldContainer,
  ButtonContainer,
  FormButton,
} from './index.styles';

export function FormTickets() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [toaster, setToaster] = useState({ open: false, msg: '' });

  const sendFeedback = async (data) => {
    setLoading(true);

    const formData = new FormData();
    formData.append('feedback_type', data.feedback_type);
    formData.append('subject', data.subject);
    formData.append('description', data.description);
    formData.append('priority', data.priority);
    files.forEach((file) => {
      formData.append(
        'feedback_attachments_attributes[][attachment_file]',
        file
      );
    });

    try {
      await api.post('/feedbacks', formData, { headers: authHeader(true) });
      setModalOpen(true);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <RootStyled>
      {toaster.open && <ToasterBox message={toaster.msg} showSeconds={5} />}
      {loading ? (
        <LinearProgress sx={{ width: '80%', margin: '30vh auto' }} />
      ) : (
        <>
          <HeaderModalStyled>
            <Button
              style={{ background: 'none', marginLeft: -18 }}
              onClick={() => navigate(-1)}
            >
              <MdArrowBack size={25} />
            </Button>
            <HeaderTitleStyled variant="h1">Suporte</HeaderTitleStyled>
            <Subtitle component="p" maxWidth="500px">
              Você encontrou um problema ou tem alguma dúvida? Preencha o
              formulário abaixo e entraremos em contato o mais breve possível.
            </Subtitle>
          </HeaderModalStyled>

          <FormContainer component="form" onSubmit={handleSubmit(sendFeedback)}>
            <FormTitle variant="h3">Envie seu feedback</FormTitle>
            <FieldContainer>
              <TextField
                fullWidth
                variant="outlined"
                label="Nome"
                {...register('name', { required: 'Campo obrigatório' })}
                error={!!errors.name}
                helperText={errors.name && errors.name.message}
              />
            </FieldContainer>
            <FieldContainer
              sx={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Controller
                name="feedback_type"
                control={control}
                rules={{ required: 'Campo obrigatório' }}
                render={({ field }) => (
                  <FormControl sx={{ width: '48%' }}>
                    <InputLabel id="feedback-type-select">
                      Tipo de Feedback
                    </InputLabel>
                    <Select
                      {...field}
                      label="Tipo de Feedback"
                      labelId="feedback-type-select"
                      error={!!errors.feedback_type}
                    >
                      <MenuItem value="question">Dúvida</MenuItem>
                      <MenuItem value="sugestion">Sugestão</MenuItem>
                      <MenuItem value="bug">Relatar Bug</MenuItem>
                      <MenuItem value="other">Outro</MenuItem>
                    </Select>
                    {!!errors.feedback_type && (
                      <FormHelperText sx={{ color: '#d32f2f' }}>
                        {errors.feedback_type.message}
                      </FormHelperText>
                    )}
                  </FormControl>
                )}
              />

              <Controller
                name="priority"
                control={control}
                rules={{ required: 'Campo obrigatório' }}
                render={({ field }) => (
                  <FormControl sx={{ width: '48%' }}>
                    <InputLabel id="priority-select">Prioridade</InputLabel>
                    <Select
                      {...field}
                      labelId="priority-select"
                      label="Prioridade"
                      error={!!errors.priority}
                    >
                      <MenuItem value="high">Alta</MenuItem>
                      <MenuItem value="medium">Média</MenuItem>
                      <MenuItem value="low">Baixa</MenuItem>
                    </Select>
                    {!!errors.priority && (
                      <FormHelperText sx={{ color: '#d32f2f' }}>
                        {errors.priority.message}
                      </FormHelperText>
                    )}
                  </FormControl>
                )}
              />
            </FieldContainer>

            <FormTitle variant="h3">No que podemos lhe ajudar?</FormTitle>
            <FieldContainer>
              <TextField
                fullWidth
                variant="outlined"
                label="Assunto"
                {...register('subject', { required: 'Campo obrigatório' })}
                error={!!errors.subject}
                helperText={errors.subject && errors.subject.message}
              />
            </FieldContainer>
            <FieldContainer>
              <TextField
                fullWidth
                variant="outlined"
                label="Mensagem"
                {...register('description', { required: 'Campo obrigatório' })}
                multiline
                rows={4}
                error={!!errors.description}
                helperText="Por favor, insira os detalhes da sua solicitação. Um membro da nossa equipe de suporte responderá o mais breve possível."
              />
            </FieldContainer>

            <FormTitle variant="h3">Anexar arquivos (opcional)</FormTitle>
            <FieldContainer>
              <FilesDropzone setFiles={setFiles} setToaster={setToaster} />
            </FieldContainer>

            {files.map(({ name, size }) => (
              <FileCard
                key={uuid()}
                name={name}
                size={size}
                setFiles={setFiles}
                files={files}
              />
            ))}

            <ButtonContainer>
              <FormButton type="reset" variant="outlined">
                Limpar
              </FormButton>
              <FormButton type="submit" variant="contained">
                Enviar
              </FormButton>
            </ButtonContainer>
          </FormContainer>

          <SuccessModal open={modalOpen} setOpen={setModalOpen} />
        </>
      )}
    </RootStyled>
  );
}
